module.exports = __webpack_public_path__ + "static/media/gopher-seeklogo.com.199f0e6e.svg";